import { createPortal } from 'react-dom';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixedCalculatorFooter({ children, styles }: any) {
    // if (typeof window === 'undefined') {
    //     return <></>;
    // }
    //const pagelayoutWapperEl = document.querySelector('.pagelayoutWapper') || document.body;
    const isMM100 = typeof window !== 'undefined' && window.location.href.includes('/calculators/power-kits');
    const { useEffect, useState } = useGlobal();
    const [isClient, setIsClient] = useState<boolean>(false);
    const [pagelayoutWapperEl, setPagelayoutWapperEl] = useState<any>();

    useEffect(() => {
        setIsClient(true);
        setPagelayoutWapperEl(document.querySelector('.pagelayoutWapper') || document.body);
        const backTopEl = document.querySelector('.backToTopBtn');
        const acsbEl = document.querySelector('.acsb-trigger');
        const fixedFooterEl = document.querySelector('.fixedCalculatorFooter');
        if (fixedFooterEl) {
            if (backTopEl) {
                backTopEl.style.bottom = `${fixedFooterEl.offsetHeight + 80}px`;
            }
            if (acsbEl) {
                acsbEl.style.inset = `auto 20px ${fixedFooterEl.offsetHeight + 20}px auto`;
                acsbEl.style.left = '10px';
            }
        }
    }, []);

    return (
        <>
            {isClient && createPortal(<div className={`fixedCalculatorFooter ${css.fixedCalculatorFooter}`}>{children}</div>, pagelayoutWapperEl)}
            <style jsx global>
                {`
                    .pagelayoutWapper {
                        ${isMM100 ? 'padding-bottom: 0.92rem !important' : ''}
                    }
                `}
            </style>
        </>
    );
}
